function sharedOptions(id) {
  const el = document.getElementById(id);
  if (!el) return [];
  if (!el.__sharedOptions) {
    try {
      el.__sharedOptions = JSON.parse(el.textContent);
    } catch (e) {
      console.error("Failed to parse shared options JSON:", e);
      el.__sharedOptions = [];
    }
  }
  return el.__sharedOptions;
}

export default function initSharedOptionsSelects(scope) {
  $("select.shared-options-select", scope)
    .not(".select2-hidden-accessible")
    .each(function () {
      const select = this;

      $(select).select2({
        width: select.dataset.width || "resolve",
        ajax: {
          delay: 0,
          data: (params) => ({ term: params.term }),
          processResults: (data) => data,
          transport(params, success) {
            const term = (params.data.term || "").toLowerCase();
            const options = sharedOptions(select.dataset.sharedOptions);
            const results = term
              ? options.filter((option) => (option.text || "").toLowerCase().includes(term))
              : options;
            success({ results });
            return { abort() {} };
          },
        },
      });
    });
}
